import { Fade, Stack } from '@mui/material';

import { Loader } from './loader';

export const LoaderBackdrop = () => {
  return (
    <Fade in={true}>
      <Stack
        width={'100vw'}
        height={'100vh'}
        display={'flex'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <Loader />
      </Stack>
    </Fade>
  );
};
